'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import NumericOperatorFilterController from "./controller/numericOperatorSelect";
import OperatorService from "./service/operator";

export default angular.module('investmentProject.operator', [])
    .controller('NumericOperatorFilterController', NumericOperatorFilterController)
    .factory('OperatorService', OperatorService)
    .name;